import React from "react";
import Layout from "@/components/Layout";
import SectionHeader from "@/components/SectionHeader";
import { useI18n } from "@/i18n";
import { faqItems } from "@/data/faq";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ() {
  const { t, lang } = useI18n();
  return (
    <Layout seoTitle={t("faq.title")} seoDescription={t("faq.subtitle")}>
      <section className="section-y">
        <div className="container-mt max-w-4xl">
          <SectionHeader as="h1" num="01" kicker="FAQ" title={t("faq.title")} subtitle={t("faq.subtitle")} />
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqItems.map((it, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-zinc-800/80"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left text-white hover:no-underline hover:text-brand-lime text-base md:text-lg font-display font-bold uppercase tracking-tight py-6 gap-6">
                  <span className="flex items-start gap-5">
                    <span className="font-mono text-brand-lime/60 text-xs mt-1 tabular-nums tracking-widest">{String(i + 1).padStart(2, "0")}</span>
                    <span>{lang === "lt" ? it.q.lt : it.q.en}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-zinc-300 text-[15px] leading-relaxed pb-6 pl-10">
                  {lang === "lt" ? it.a.lt : it.a.en}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </Layout>
  );
}
